<template>
  <div>
    <!-- Filters for auction results -->
    <div v-if="auctionsType === 'results' || auctionsType === 'rezultate' || auctionsType === 'rezultati'"
         class="col-lg-10 offset-lg-1 col-12 py-2 mt-4 py-sm-0">
      <h1 class="h4 text-uppercase header_decoration mb-4">{{ __('refine_lots') }}</h1>
      <div class="row">
        <div class="col-md-4 ml-3 mb-3 mb-md-0">
          <div class="row">
            <h5 class="h5">{{ __('date_filter_label') }}</h5>
          </div>
          <div class="row">
            <div class="col-12 pl-0">
              <datepicker
                  :input-class="'form-control myAccount-form-control-custom box_select_no_borders border-bottom cursor-pointer'"
                  :calendar-class="'w-100'"
                  :monday-first="true"
                  :language="locale"
                  :format="'MMMM yyyy'"
                  :minimumView="'month'"
                  :maximumView="'month'"
                  :disabled-dates="{to: (!userGroup||userGroup==='2')?$dayjs().startOf('year').subtract(2,'year').toDate():''}"
                  :placeholder="__('date_filter_placeholder')"
                  v-model="selectedMonth"
                  @closed="applyResultsFilters"
              ></datepicker>
            </div>
          </div>
        </div>

        <div class="col-md-2 ml-3 mb-3 mb-md-0">
          <div class="row">
            <h5 class="h5">{{ __('location') }}</h5>
          </div>
          <div class="row">
            <div class="col-12 pl-0">
              <select v-model="show_auctions_by_domain"
                      class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                      name="show-auctions-by-domain">
                <option value="all">{{ __('all_auctions') }}</option>
                <option value="local">{{ __('local_auctions') }}</option>
                <option value="international">{{ __('international_auctions') }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-4 ml-3 mb-3 mb-md-0">
          <div class="row">
            <h5 class="h5">{{ __('manage_filters') }}</h5>
          </div>
          <div class="row">
            <div class="d-flex justify-content-end pt-4">
              <button
                  class="btn btn-link text-dark p-0 nounderline cursor-pointer h8"
                  @click="clearFilters"
              >{{ __('clear_filters') }}
              </button>
            </div>
            <div class="d-flex justify-content-end pt-4">
              <button
                  class="btn btn-link text-dark p-0 nounderline cursor-pointer h8 separator"
                  @click="showAllAuctions()"
                  v-if="!showAllTheAuctions"
              >{{ __('show_all_auctions') }}
              </button>
              <button
                  class="btn btn-link text-dark p-0 nounderline cursor-pointer h8 separator clearFilter "
                  @click="clearFilters"
                  v-if="showAllTheAuctions"
              >{{ __('hide_all_auctions') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loader center-vertically my-5" v-if="loading">
      <svg
          version="1.1"
          id="da-loader"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="40px"
          height="40px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
      >
        <path
            fill="#000"
            d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
        >
          <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>

    <!-- Current And Future Auction Listing -->
    <div
        v-if="((auctionsType === 'current' || auctionsType === 'future') || (auctionsType === 'curente' || auctionsType === 'viitoare')|| (auctionsType === 'u-tijekug' || auctionsType === 'buduce')) && !loading"
        class="col-xl-10 offset-xl-1 pb-5"
    >
      <h5 class="h5 text-left m-0 pt-5 "><u>{{ __('local_auctions') }}</u></h5>
      <h5 v-if="localAuctions.length == 0 && (auctionsType==='current' || auctionsType==='curente' || auctionsType==='u-tijekug')"
          class="h5 text-center m-0 mt-5 text-muted pt-5"
      >{{ __('auctions_coming_soon') }}</h5>

      <div v-else>
        <div v-for="(localAuction, index) in localAuctions" :key="localAuction.id">
          <div v-if="localAuction.name" class="row pt-5 center-vertically">
            <div class="col-lg-1 col-3 order-2 order-lg-1 text-center d-none d-md-block">
              <h5 class="h2 mb-0">
                {{ localAuction.display_day }}
              </h5>

              <span class="landing_page_auction_year text-uppercase pb-1">
                {{ localAuction.display_month_year }}
              </span>

              <span
                  class="landing_page_auction_day_and_hour text-capitalize"
                  style="font-weight: bold !important;color:red !important;"
              >
                {{ localAuction.display_weekday_upper }}
              </span>

              <span
                  v-if="localAuction.display_hour"
                  class="landing_page_auction_day_and_hour"
                  style="font-weight: bold !important;color:red !important;"
              >
                {{ localAuction.display_hour }}
              </span>
            </div>

            <div class="col-lg-5 col-12 col-md-9 order-3 order-lg-2 d-flex flex-column">
              <a v-if="auctionsType != 'future' && auctionsType != 'viitoare' && auctionsType != 'buduce'"
                 :href="localAuction.url"
                 class="nounderline">
                <div class="h6 text-uppercase mb-3 pb-3 border-bottom font-weight-bold"
                     style="line-height: 1.5">
                  <span v-if="getLocale() == 'ro' && localAuction.id == 1026">
                   Legends. Licitație de sport, muzică și obiecte de colecție contemporane
                  </span>
                  <span v-else-if="getLocale() != 'ro' && localAuction.id == 1026">
                    Legends. Contemporary Sports, Music & Collectibles Auction"
                  </span>
                  <span v-else>
                   {{ localAuction.name }}
                  </span>
                  <br/>

                  <a
                      :href="artmarkLiveLink"
                      v-if="settings && localAuction.auction_is_live !== 0"
                      style="display:inline-grid;margin-top:0px;padding-top:5px;"
                      class="h4"
                  >
                    <p class="live_status d-inline auction_live_now p-2 m-0 h7 text-capitalize">
                      <strong>{{ __LIVE('auction-is-live') }}</strong>
                    </p>
                  </a>
                </div>
              </a>

              <div
                  v-else
                  class="h6 text-uppercase mb-3 pb-3 border-bottom font-weight-bold"
                  style="line-height: 1.5"
              >
                {{ localAuction.name }}
                <br/>

                <a
                    :href="artmarkLiveLink"
                    v-if="settings && localAuction.auction_is_live !== 0"
                    style="display:inline-grid;margin-top:0px;padding-top:5px;"
                    class="h4"
                >
                  <p class="live_status d-inline auction_live_now p-2 m-0 h7 text-capitalize">
                    <strong>{{ __LIVE('auction-is-live') }}</strong>
                  </p>
                </a>
              </div>

              <div
                  v-if="localAuction.display_mobile_date"
                  class="h6 text-muted m-0 pb-3 mb-3 border-bottom d-md-none text-capitalize"
              >
                <span
                    class="h6 text-muted m-0 pb-3 mb-3 border-bottom"
                    style="font-weight: bold !important;color:red !important;"
                >
                  {{ localAuction.display_mobile_date_upper }}
                </span>
              </div>

              <div
                  v-if="localAuction.display_location"
                  class="h6 text-muted m-0 pb-3 mb-3 border-bottom"
                  :style="
                    localAuction.highlight_start_date
                      ? 'font-weight: bold !important;color:red !important;'
                      : ''
                  "
              >
                {{ localAuction.display_location }}
              </div>

              <div
                  class="d-flex flex-lg-row flex-column justify-content-lg-start align-items-end align-items-lg-center">
                <!--                class="d-flex flex-row justify-content-lg-between align-items-lg-center justify-content-lg-between align-items-end auction_buttons_row">-->
                <button
                    v-if="localAuction.display_is_future_or_current && localAuction.calendar_link_google && localAuction.calendar_link_ics"
                    class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1"
                    @click="getModalInfo(localAuction)"
                    data-toggle="modal"
                    data-target="#calendarModal">{{ __('add_to_calendar') }}
                </button>

                <a v-if="localAuction.visibility === 1 && auctionsType != 'future' && auctionsType != 'viitoare'"
                   class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1 ml-1 button_lots"
                   :href="localAuction.url">
                  <div>
                    <span>{{ __('see_lots') }}</span>
                  </div>
                </a>

                <a v-if="localAuction.parent_id == 3 || localAuction.parent_id == 110"
                   class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1 ml-1"
                   :href="amLiveLink">
                  <div>
                    <span> {{ __('bid-online') }} </span>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-lg-6 order-1 order-lg-3 mb-3">
              <a v-if="auctionsType != 'future' && auctionsType != 'viitoare' && auctionsType != 'buduce'"
                 :href="localAuction.url">
                <img :src="localAuction.main_image_url" width="100%"/>
              </a>
              <img v-else :src="localAuction.main_image_url" width="100%"/>
            </div>
          </div>
        </div>
      </div>

      <h5 class="h5 text-left m-0 pt-5 "><u>{{ __('international_auctions') }}</u></h5>
      <h5 v-if="internationalAuctions.length == 0 && (auctionsType==='current' || auctionsType==='curente' || auctionsType==='u-tijekug')"
          class="h5 text-center m-0 mt-5 text-muted pt-5"
      >{{ __('auctions_coming_soon') }}</h5>

      <div v-else>
        <div v-for="(internationalAuction, index) in internationalAuctions" :key="internationalAuction.id">
          <div v-if="internationalAuction.name" class="row pt-5 center-vertically">
            <div class="col-lg-1 col-3 order-2 order-lg-1 text-center d-none d-md-block">
              <h5 class="h2 mb-0">
                {{ internationalAuction.display_day }}
              </h5>

              <span class="landing_page_auction_year text-uppercase pb-1">
                {{ internationalAuction.display_month_year }}
              </span>

              <span
                  class="landing_page_auction_day_and_hour text-capitalize"
                  style="font-weight: bold !important;color:red !important;"
              >
                {{ internationalAuction.display_weekday }}
              </span>

              <span
                  v-if="internationalAuction.display_hour"
                  class="landing_page_auction_day_and_hour"
                  style="font-weight: bold !important;color:red !important;"
              >
                {{ internationalAuction.display_hour }}
              </span>
            </div>

            <div class="col-lg-5 col-12 col-md-9 order-3 order-lg-2 d-flex flex-column">
              <a v-if="auctionsType != 'future' && auctionsType != 'viitoare' && auctionsType != 'buduce'"
                 :href="internationalAuction.url"
                 class="nounderline">
                <div
                    class="h6 text-uppercase mb-3 pb-3 border-bottom font-weight-bold"
                    style="line-height: 1.5"
                >
                  {{ internationalAuction.name }}
                  <br/>

                  <a
                      :href="artmarkLiveLink"
                      v-if="settings && internationalAuction.auction_is_live !== 0"
                      style="display:inline-grid;margin-top:0px;padding-top:5px;"
                      class="h4"
                  >
                    <p class="live_status d-inline auction_live_now p-2 m-0 h7 text-capitalize">
                      <strong>{{ __LIVE('auction-is-live') }}</strong>
                    </p>
                  </a>
                </div>
              </a>

              <div
                  v-else
                  class="h6 text-uppercase mb-3 pb-3 border-bottom font-weight-bold"
                  style="line-height: 1.5"
              >
                {{ internationalAuction.name }}
                <br/>

                <a
                    :href="artmarkLiveLink"
                    v-if="settings && internationalAuction.auction_is_live !== 0"
                    style="display:inline-grid;margin-top:0px;padding-top:5px;"
                    class="h4"
                >
                  <p class="live_status d-inline auction_live_now p-2 m-0 h7 text-capitalize">
                    <strong>{{ __LIVE('auction-is-live') }}</strong>
                  </p>
                </a>
              </div>

              <div
                  v-if="internationalAuction.display_mobile_date"
                  class="h6 text-muted m-0 pb-3 mb-3 border-bottom d-md-none text-capitalize"
              >
                {{ internationalAuction.display_mobile_date }}
              </div>

              <div
                  v-if="internationalAuction.display_location"
                  class="h6 text-muted m-0 pb-3 mb-3 border-bottom"
                  :style="
                    internationalAuction.highlight_start_date
                      ? 'font-weight: bold !important;color:red !important;'
                      : ''
                  "
              >
                {{ internationalAuction.display_location }}
              </div>

              <div
                  class="d-flex flex-lg-row flex-column justify-content-lg-start align-items-end align-items-lg-center">
                <!--                class="d-flex flex-row justify-content-lg-between align-items-lg-center justify-content-lg-between align-items-end auction_buttons_row">-->
                <button
                    v-if="internationalAuction.display_is_future_or_current && internationalAuction.calendar_link_google && internationalAuction.calendar_link_ics"
                    class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1"
                    @click="getModalInfo(internationalAuction)"
                    data-toggle="modal"
                    data-target="#calendarModal">{{ __('add_to_calendar') }}
                </button>

                <a v-if="internationalAuction.visibility === 1 && auctionsType != 'future' && auctionsType != 'viitoare'"
                   class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1 ml-1 button_lots"
                   :href="internationalAuction.url">
                  <div>
                    <span>{{ __('see_lots') }}</span>
                  </div>
                </a>

                <a v-if="internationalAuction.parent_id == 3 || internationalAuction.parent_id == 110"
                   class="btn action_box action_box_full_width_mobile action_box_auctions rounded-0 text-uppercase mb-1 ml-1"
                   :href="amLiveLink">
                  <div>
                    <span> {{ __('bid-online') }} </span>
                  </div>
                </a>
              </div>
            </div>

            <div class="col-lg-6 order-1 order-lg-3 mb-3">
              <a v-if="auctionsType != 'future' && auctionsType != 'viitoare' && auctionsType != 'buduce'"
                 :href="internationalAuction.url">
                <img :src="internationalAuction.main_image_url" width="100%"/>
              </a>
              <img v-else :src="internationalAuction.main_image_url" width="100%"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Auction Results Listing -->
    <div v-if="(auctionsType === 'results' || auctionsType === 'rezultate'|| auctionsType === 'rezultati') && !loading"
         class="col-12 col-lg-10 offset-lg-1 pb-5">
      <h2 v-if="!auctions" class="h5 text-center m-0 mt-5 text-muted">{{ __('no_auctions') }}</h2>

      <div v-else>
        <h5 v-if="showByDomain == 'local'" class="h5 text-left m-0 pt-0 pt-md-5 mb-5">
          <u>{{ __('local_auctions') }}</u>
        </h5>
        <h5 v-else-if="showByDomain == 'international'" class="h5 text-left m-0 pt-5 mb-5">
          <u>{{ __('international_auctions') }}</u>
        </h5>
        <h5 v-else class="h5 text-left m-0 pt-5 mb-5">
          <u>{{ __('all_auctions') }}</u>
        </h5>

        <div v-for="(auction, index) in auctions" :key="auction.id">
          <div
              v-if="auction.name"
              class="row py-2 border-bottom center-vertically"
              :class="{ 'border-top': index === 0 }"
          >
            <div class="col-lg-1 pr-0 text-center d-none d-lg-block">
              <h5 class="h2 mb-0">
                {{ auction.display_day }}
              </h5>

              <span class="landing_page_auction_year text-uppercase pb-1">
                {{ auction.display_month_year }}
              </span>

              <span class="landing_page_auction_day_and_hour text-capitalize">
                {{ auction.display_weekday }}
              </span>
            </div>

            <div class="col-lg-1 d-lg-none">
              <h4 class="h6 m-0 py-3">
                {{ auction.display_short_date }}
              </h4>
            </div>

            <div class="col-lg-3 py-2 text-center d-none d-lg-block">
              <a :href="makeAuctionUrl(auction)">
                <img :src="auction.thumbnail_url" width="200px"/>
              </a>
            </div>

            <div class="col-lg-3 py-2 text-center d-lg-none">
              <a :href="makeAuctionUrl(auction)">
                <img :src="auction.main_image_url" width="100%"/>
              </a>
            </div>

            <div class="col-lg-5 flex-column text-left">
              <a :href="makeAuctionUrl(auction)" class="nounderline">
                <h4
                    class="h6 pt-3 text-uppercase font-weight-bold"
                    style="line-height: 1.5"
                >{{ auction.name }}</h4>
              </a>

              <h5 class="h7 text-muted pt-3 m-0">
                {{ __('sale_total') }}:
                <span class="text-dark">{{ auction.total }} &euro;</span>
                <br/>
                {{ __('total_sale_percentage') }}:
                <span class="text-dark">{{ auction.sold_rate }}&#37;</span>
              </h5>

              <h5 class="h7 text-muted">
                {{ __('location') }}:
                <span class="text-dark">{{ auction.display_location }}</span>
              </h5>
            </div>

            <div class="col-lg-3 py-3 d-flex justify-content-start justify-content-lg-end">
              <a class="action_box action_box_results text-uppercase" :href="makeAuctionUrl(auction)">
                {{ __('results') }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="auctions" class="row pagination mt-5 px-4">
        <div class="col-1"></div>
        <div class="col text-center my-4">
          <nav aria-label="labels" style="background: white !important;">
            <ul class="pagination justify-content-center">
              <li v-if="currentPage >= 2" class="page-item prev" :class="hasPrevious()">
                <router-link
                    class="page-link"
                    :to="{name: 'auctions', params: {type: auctionsType, page: parseInt(currentPage) - 1}}"
                >
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5" points="13 16 7 10 13 4"/>
                  </svg>
                </router-link>
              </li>

              <li class="page-item" :class="isCurrentPage(page)" v-for="page in proximityPages">
                <router-link
                    class="page-link"
                    :to="{name: 'auctions', params: {type: auctionsType, page: page}}"
                >{{ page }}
                </router-link>
              </li>

              <li v-if="currentPage <= lastPage - 1" class="page-item next" :class="hasNext()">
                <router-link
                    class="page-link"
                    :to="{name: 'auctions', params: {type: auctionsType, page: parseInt(currentPage) + 1}}"
                >
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5" points="7 4 13 10 7 16"/>
                  </svg>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-1"></div>
      </div>
    </div>

    <!-- Calendar Modal -->
    <div
        v-if="modal"
        class="modal fade p-0"
        id="calendarModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="calendarModal"
        aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="link">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h4 class="modal-title h5">{{ __('add_to_calendar') }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <h5
              class="h5 text-center text-muted mt-5 mb-3 px-3"
          >{{ __('calendar_modal_select_an_option') }}</h5>

          <div class="row px-3 py-3">
            <a
                :href="modal.auction.calendar_link_google"
                @click="open_link(modal.auction.calendar_link_google)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >Google</a>

            <a
                :href="modal.auction.calendar_link_ics"
                @click="open_link(modal.auction.calendar_link_ics)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >Outlook</a>

            <a
                :href="modal.auction.calendar_link_ics"
                @click="open_link(modal.auction.calendar_link_ics)"
                class="col-4 h5 nounderline text-center m-0 py-3"
                target="_blank"
                data-dismiss="modal"
            >iPhone</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {en, ro, hr, bg} from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import * as types from "../store/mutations";

export default {
  name: "Auctions",
  props: [],
  components: {
    Datepicker
  },
  data: function () {
    return {
      showByDomain: 'local',
      showAllTheAuctions: false,
      loading: false,
      currentLanguage: "",
      selectedMonth: "",
      currentPage: "",
      countLocalAuctions: "",
      countInternationalAuctions: "",
      lastPage: "",
      modal: {
        auction: ""
      },
      //Datepicker languages
      en: en,
      ro: ro,
      hr: hr,
      bg: bg
    };
  },
  computed: {
    show_auctions_by_domain: {
      get: function () {
        return this.showByDomain;
      },
      set: function (showByDomain) {
        this.showByDomain = showByDomain;
        this.loadAuctions("no-pagination");
      }
    },
    domain: function () {
      return window.AG.domain;
    },
    artmarkLiveLink: function () {
      return window.AG.artmark_live;
    },
    amLiveLink: function () {
      return window.AG.am_live;
    },
    settings: function () {
      return window.AG.settings.live_auction;
    },
    userGroup: function () {
      return window.AG.userGroup;
    },
    locale: function () {
      switch (window.AG.locale) {
        case "ro":
          return this.ro;
          break;
        case "en":
          return this.en;
          break;
        case "bg":
          return this.bg;
          break;
        case "hr":
          return this.hr;
          break;
      }
    },
    auctionsType: function () {
      return this.$route.params.type;
    },
    auctions: function () {
      return this.$store.getters.auctions;
    },
    localAuctions: function () {
      return this.$store.getters.auctions.filter(auction => auction.domain == this.domain);
    },
    internationalAuctions: function () {
      return this.$store.getters.auctions.filter(auction => auction.domain != this.domain);
    },
    proximityPages() {
      if (!this.currentPage) {
        return "";
      }
      var curr = this.currentPage;
      var total = this.lastPage;
      var pages = [
        curr - 3,
        curr - 2,
        curr - 1,
        curr,
        curr + 1,
        curr + 2,
        curr + 3
      ].filter(function (value) {
        if (value <= 0) {
          return false;
        } else if (value > total) {
          return false;
        }
        return true;
      });
      return pages;
    }
  },
  methods: {
    getLocale() {
      return window.AG.locale;
    },
    open_link: function (url) {
      window.open(url, "_blank");
    },
    showAllAuctions() {
      this.loadAuctions("no-pagination");
      this.showAllTheAuctions = true;
    },
    __(key) {
      return window.AG.trans[key];
    },
    __LIVE(key) {
      return window.AG.generic[key];
    },
    loadAuctions(pagination) {
      this.loading = true;

      if (pagination === "no-pagination") {
        var pagination = "no-pagination";
      } else {
        var pagination = "with-default-pagination";
      }

      var payload = {
        benefit: this.$route.meta.benefit ? 1 : 0,
        paginate: pagination,
        type: this.auctionsType,
        page: this.$route.params.page,
        user_email: window.AG.loggedIn,
        showByDomain: this.showByDomain
      };

      this.$store.dispatch("loadAuctions", payload).then(data => {
        this.countInternationalAuctions = data.countInternationalAuctions;
        this.countLocalAuctions = data.countLocalAuctions;
        if (this.auctionsType === "results" || this.auctionsType === "rezultate" || this.auctionsType === "rezultati") {
          this.currentPage = data.current_page;
          this.lastPage = data.last_page;
          if (this.auctions != null) {
            if (
                this.auctions.selected_month_filter &&
                this.auctions.selected_year_filter
            ) {
              var month = this.$dayjs(
                  this.auctions.selected_year_filter +
                  "-" +
                  this.auctions.selected_month_filter +
                  "-01"
              )
                  .locale("en")
                  .format("MMMM");
              this.selectedMonth =
                  month + " " + this.auctions.selected_year_filter;
            }
          }
        }
        this.loading = false;
      });
    },
    applyResultsFilters() {
      var payload = {
        type: this.auctionsType,
        page: this.$route.params.page,
        benefit: this.$route.meta.benefit ? 1 : 0,
        showByDomain: this.showByDomain,
        filters: {
          month: this.$dayjs(this.selectedMonth).format("YYYY-MM")
        }
      };
      this.$store.dispatch("loadAuctions", payload).then(data => {
        if (!data.message) {
          this.currentPage = data.current_page;
          this.lastPage = data.last_page;
        }
      });
    },
    clearFilters() {
      var payload = {
        type: this.auctionsType
      };
      this.$store.dispatch("clearAuctionsFilters", payload).then(data => {
        this.loadAuctions();
        this.selectedMonth = "";
        this.startDate = "";
        this.endDate = "";
      });
      this.showAllTheAuctions = false;
    },
    hasPrevious() {
      return this.currentPage == 1 ? "disabled" : "";
    },
    hasNext() {
      return this.currentPage == this.lastPage ? "disabled" : "";
    },
    isCurrentPage(page) {
      return this.currentPage == page ? "active" : "";
    },
    getModalInfo(auction) {
      this.modal.auction = auction;
    },
    makeAuctionUrl(auction) {
      return auction.url;
    },
  },
  mounted() {
    this.$dayjs.locale(window.AG.locale);
    this.loadAuctions();
  }
};
</script>
